import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import matchSorter from 'match-sorter';
import { FormGroup } from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  userIsAdmin,
  userIsManager,
} from '../../helpers/Auth';

import AccessModalAddNew from './ModalAddNew';
import AccessModalSelectItem from './ModalSelectItem';
import SelectVirtualMenuList from '../SelectVirtualMenuList';

class AccessModalSelect extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  getOptions() {
    const {
      listType,
      groups,
      users,
      selectedGroups,
      selectedUsers,
      singleSelect,
    } = this.props;
    const items = listType === 'groups' ? groups : users;
    const selected = listType === 'groups' ? selectedGroups : selectedUsers;

    const options = [];
    if (singleSelect && Object.keys(selected).length > 0) {
      items
        .filter(i => (selected[i.uuid]))
        .filter(i => (!i.deactivated_at))
        .forEach((i) => {
          if (listType === 'groups') {
            options.push({
              uuid: i.uuid,
              name: i.name,
              type: 'group',
            });
          }
          if (listType === 'users') {
            options.push({
              uuid: i.uuid,
              name: i.name,
              email: i.email,
              avatar: i.avatar_url,
              type: 'user',
            });
          }
        });
    }

    items
      .filter(i => (!selected[i.uuid]))
      .filter(i => (!i.deactivated_at))
      .forEach((i) => {
        if (listType === 'groups') {
          options.push({
            uuid: i.uuid,
            name: i.name,
            type: 'group',
          });
        }
        if (listType === 'users') {
          options.push({
            uuid: i.uuid,
            name: i.name,
            email: i.email,
            avatar: i.avatar_url,
            type: 'user',
          });
        }
      });

    return options;
  }

  getSelected() {
    const {
      listType,
      selectedGroups,
      selectedUsers,
    } = this.props;

    const selectedUuids = listType === 'groups' ? Object.keys(selectedGroups) : Object.keys(selectedUsers);
    return this.getOptions().find(i => (selectedUuids.includes(i.uuid))) || null;
  }

  getPlaceholder() {
    const {
      intl,
      listType,
      loading,
    } = this.props;

    if (loading) {
      return 'Loading...';
    }

    return (
      listType === 'groups' ?
        intl.formatMessage({ defaultMessage: 'Type or select Team names...' }) :
        intl.formatMessage({ defaultMessage: 'Type user name or email...' })
    );
  }

  handleChange(value) {
    const { handleAddItem } = this.props;

    if (!value || !value.uuid) {
      handleAddItem(null);
    } else {
      handleAddItem(value.uuid);
    }
  }

  render() {
    const {
      listType,
      singleSelect,
      showAddNewButton,
      loading,
      handleAddNewItem,
    } = this.props;
    const { inputValue } = this.state;

    return (
      <FormGroup>
        <Select
          id={listType === 'groups' ? 'inpModalAccessAddGroup' : 'inpAccessAddUser'}
          inputId={listType === 'groups' ? 'inpAccessAddGroupInput' : 'inpAccessAddUserInput'}
          name={listType === 'groups' ? 'accessAddGroup' : 'accessAddUser'}
          className={listType === 'groups' ? 'access-group-select user-select' : 'access-user-select user-select'}
          classNamePrefix="user-select"
          placeholder={this.getPlaceholder()}
          noOptionsMessage={() => (listType === 'groups' ? 'No Teams' : 'No users')}
          getOptionValue={option => option.uuid}
          getOptionLabel={option => option.name}
          components={{
            Option: AccessModalSelectItem,
            MenuList: listType === 'users' ? SelectVirtualMenuList : components.MenuList,
          }}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          menuPortalTarget={document.body}
          isDisabled={loading}
          isLoading={loading}
          isClearable={singleSelect}
          onChange={this.handleChange}
          options={matchSorter(this.getOptions(), inputValue, { keys: ['name', 'email'] })}
          filterOption={false}
          onInputChange={(v) => { this.setState({ inputValue: v }); }}
          value={singleSelect ? this.getSelected() : null}
        />
        {(showAddNewButton && (userIsAdmin() || userIsManager())) && (
          <AccessModalAddNew
            listType={listType}
            handleAddNew={handleAddNewItem}
          />
        )}
      </FormGroup>
    );
  }
}

AccessModalSelect.propTypes = {
  intl: PropTypes.object.isRequired,
  listType: PropTypes.string.isRequired,
  groups: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  selectedGroups: PropTypes.object,
  selectedUsers: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  singleSelect: PropTypes.bool,
  showAddNewButton: PropTypes.bool,
  handleAddItem: PropTypes.func.isRequired,
  handleAddNewItem: PropTypes.func,
};

AccessModalSelect.defaultProps = {
  selectedGroups: {},
  selectedUsers: {},
  singleSelect: false,
  showAddNewButton: false,
  handleAddNewItem: () => { },
};

export default injectIntl(AccessModalSelect);
